import { render, staticRenderFns } from "./SubcategoryCard.vue?vue&type=template&id=a7170dbe&scoped=true"
import script from "./SubcategoryCard.vue?vue&type=script&lang=ts"
export * from "./SubcategoryCard.vue?vue&type=script&lang=ts"
import style0 from "./SubcategoryCard.vue?vue&type=style&index=0&id=a7170dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7170dbe",
  null
  
)

export default component.exports